import { render, staticRenderFns } from "./AuthenticationMethods.vue?vue&type=template&id=bf7ab4d6&scoped=true"
import script from "./AuthenticationMethods.vue?vue&type=script&lang=ts"
export * from "./AuthenticationMethods.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticationMethods.vue?vue&type=style&index=0&id=bf7ab4d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7ab4d6",
  null
  
)

export default component.exports